import { lazy } from "react";
import ScriptCache from "./ScriptCache";

const fetchFormUrl = async () => {
	return fetch("/api/settings/authConfig/FormsUrl", { method: "GET" }).then(
		(res) => {
			return res.text();
		}
	);
};

const FetchDployScript = lazy(async () => {
	const formUrl: string = await fetchFormUrl();

	const scriptCache = new ScriptCache({
		src: formUrl,
	});

	const scriptToLoad = await scriptCache.load();

	return {
		default: ({ children }) => children(scriptToLoad),
	};
});

export default FetchDployScript;
